
const picUrl='http://47.96.229.180/trade/mobile/images/business_logo.jpg';
const auditNoUrl='http://47.96.229.180/trade/mobile/images/audit_no.png';
const auditPassUrl='http://47.96.229.180/trade/mobile/images/audit_pass.png';
const auditCheckUrl='http://47.96.229.180/trade/mobile/images/audit_check.png';
const mpUrl='http://47.96.229.180/trade/mobile/images/MP.png';
const cpUrl='http://47.96.229.180/trade/mobile/images/CP.png';
const noPicUrl='http://47.96.229.180/trade/mobile/images/No_pic.png'
const currentObjs=[];
const currentUser=undefined;
  export default
  {
    auditNoUrl,
    auditPassUrl,
    auditCheckUrl,
    mpUrl,
    cpUrl,
    noPicUrl,
    picUrl,//图片地址
    currentObjs,//当前数据
    currentUser,//当前登录账号信息
  }



// WEBPACK FOOTER //
// ./src/GLOBAL.vue